var _defs, _path, _rect, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedingLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.06 38.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e68ec;}.cls-2{fill:#191d21;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedingLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-97,5025.32h0a19,19,0,0,1-19-19,19,19,0,0,1,19-19,19,19,0,0,1,19,19A19,19,0,0,1-97,5025.32Z",
    transform: "translate(116.04 -4987.26)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.4,
    y: 14.79,
    width: 3.94,
    height: 12.72
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 12.35,
    cy: 10.77,
    rx: 2.33,
    ry: 2.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-95.41,5008.1c0-1.79.82-2.85,2.4-2.85s2.14,1,2.14,2.85v6.68h3.92v-8.06c0-3.41-1.93-5.06-4.63-5.06a4.44,4.44,0,0,0-3.83,2.1v-1.71h-3.78v12.72h3.78v-6.68Z",
    transform: "translate(116.04 -4987.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedingLogo);
export default __webpack_public_path__ + "static/media/linkedingLogo.20986eb99a404f48491446b60342dd52.svg";
export { ForwardRef as ReactComponent };